import { render, staticRenderFns } from "./SysSegmentoAutocomplete.vue?vue&type=template&id=02880aa8&scoped=true"
import script from "./SysSegmentoAutocomplete.vue?vue&type=script&lang=js"
export * from "./SysSegmentoAutocomplete.vue?vue&type=script&lang=js"
import style0 from "./SysSegmentoAutocomplete.vue?vue&type=style&index=0&id=02880aa8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02880aa8",
  null
  
)

export default component.exports